<template>
  <div class="api__bg">
    <div class="api__navbar">
      <div
        class="api__navbar-option"
        v-for="(item, index) in dataModel[props.brandExperience].ui.retailers"
        :key="item.endpoint"
        :style="{ backgroundColor: item.bgColor }"
        :data-id="index"
      >
        <div class="api__navbar-text">{{ dataModel[index].prodName }}</div>
      </div>
    </div>
    <div class="api">
      <div
        v-for="item in dataModel[props.brandExperience].retailers"
        :key="item.retailer"
        class="api__retailer" style="background-color: green"
      >
        <a data-action="csClickToRetailer" :href="item.url" class="api__a" target="_blank">
          <div data-action="csClickToRetailer" class="api__img-wrapper temp__center">
            <img data-action="csClickToRetailer" :src="item.logo" class="api__img--logo" />
          </div>
          <div data-action="csClickToRetailer" class="api__price">&pound;{{ item.price }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";
import gsap from "gsap";
import { ExpoScaleEase, RoughEase, SlowMo } from "gsap/EasePack";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
gsap.registerPlugin(ExpoScaleEase, RoughEase, SlowMo, CSSRulePlugin);

const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});


$(document).ready(function () {

  function overflowCheck() {
      let elem = $(".api__bg").get(0);
      if (elem.offsetHeight < elem.scrollHeight || elem.offsetWidth < elem.scrollWidth) { // element has overflow
          $(".api").css({'justify-content': 'flex-start'});
      } else { // element doesn't have overflow
          $(".api").css({'justify-content': 'center'});
      }
  }

  gsap.set('.hero', {
    opacity: 0
  })

  $(".api__price").css({
    backgroundColor: "#006939",
  });

  gsap.set('.hero__img--prod', {
    x: () => {
      if(window.innerWidth <= 600) {
        return 400
      }
    }
  })
 
  $(".api__navbar-option").on("click", function () {
    
    overflowCheck();

    var dId = $(this).attr("data-id");

    //animation for the background images
    $('.hero--' + dId).appendTo('.hero__wrapper');
    gsap.to('.hero--' + dId, {
      duration: .5,
      opacity: 1,
      onComplete: () => {
        var i;
        var heroElem = $('.hero');
        for(i=1; i<heroElem.length+1; i++) {
          if(i == dId) {
          } else {
            console.log(i)
              $('.hero--'+i).css({
                opacity: 0
              })
            
          }
        }
      }
    });

    gsap.to('.hero__img--prod', {
      duration: .5,
      x: () => {
        if(window.innerWidth <= 600) {
          return 400
        }
      }
    })

    gsap.to('.hero__img--prod--' + dId + '--active', {
      duration: .5,
      delay: .5,
      x: () => {
        if(window.innerWidth <= 600) {
          return 0
        }
      }
    })
    
    //functionality to scroll the navbar element 
    //to the end if brandContext == 3 
    function animateOverflow(targetElement, speed) {
      var scrollWidth = $(targetElement).get(0).scrollWidth;
      var clientWidth = $(targetElement).get(0).clientWidth;
      $(targetElement).animate({ scrollLeft: scrollWidth - clientWidth }, {
        duration: speed,
      });
    };

    //functionality to scroll the navbar element 
    //to the end if brandContext == 3 
    function animateOverflowBack(targetElement, speed) {
      $(targetElement).animate({ scrollLeft: 0 }, {
        duration: speed,
      });
    };

    $(".api__navbar-option").removeClass("pseudo-active");

    switch (dataModel[1].ui.retailers[dId].bgColor) {
      case "#f00091":
        //add the down arrow to selected tab
        $(this).addClass("pseudo-active--pink");
        if(window.innerWidth > 600) {
          gsap.to('.hero__img--prod--1--inactive', {
            duration: .25,
            opacity: 0
          })
          gsap.to('.hero__img--prod--2--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--3--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--4--inactive', {
            duration: .25,
            opacity: 1
          })
          
        }
        //animate the logo
        gsap.to('.hero__logo', {
          duration: .25,
          opacity: 0,
          onComplete: () => {
            gsap.to('.hero__logo--1', {
              opacity: 1
            })
          }
        })
        //animate the copy
        gsap.to('.hero__copy', {
          duration: .25,
          opacity: 0,
          y: 20,
          onComplete: () => {
            $('.hero__copy').html('<div class="hero__copy-row"><span>Smirnoff</span></div> <div class="hero__copy-row"><span>Raspberry</span> <span>Crush</span></div>')
          }
        });
        animateOverflowBack($('.api__navbar'), 500);
        gsap.to('.hero__copy', {
          duration: .25,
          delay: .25,
          opacity: 1,
          y: 0,
        });
        //animate the side tabs
        gsap.to('.hero__tab--1', {
          duration: .25,
          x: 0
        });
        //animate the side tabs
        gsap.to('.hero__tab--2', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--3', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--4', {
          duration: .25,
          x: -140
        });
        $('body').css({
          backgroundImage: "url('hero/marble-bg.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
        
        break;
      
        case "#fab80e":
        //add the down arrow to selected tab
        $(this).addClass("pseudo-active--yellow");
        if(window.innerWidth > 600) {
          gsap.to('.hero__img--prod--2--inactive', {
            duration: .25,
            opacity: 0
          })
          gsap.to('.hero__img--prod--1--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--3--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--4--inactive', {
            duration: .25,
            opacity: 1
          })
        }
        //animate the logo
        gsap.to('.hero__logo', {
          duration: .25,
          opacity: 0,
          onComplete: () => {
            gsap.to('.hero__logo--1', {
              opacity: 1
            })
          }
        })
        //animate the copy
        gsap.to('.hero__copy', {
          duration: .25,
          opacity: 0,
          y: 20,
          onComplete: () => {
            $('.hero__copy').html('<div class="hero__copy-row"><span>Smirnoff</span></div> <div class="hero__copy-row"><span>Mango &</span> <span>Passionfruit</span> <span>Twist</span></div>')
          }
        });
        gsap.to('.hero__copy', {
          duration: .25,
          delay: .25,
          opacity: 1,
          y: 0,
        });
        animateOverflowBack($('.api__navbar'), 500);
        
        //animate the side tabs
        gsap.to('.hero__tab--2', {
          duration: .25,
          x: 0
        });
        //animate the side tabs
        gsap.to('.hero__tab--1', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--3', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--4', {
          duration: .25,
          x: -140
        });
        $('body').css({
          backgroundImage: "url('hero/marble-bg.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
        break;
      
      case "#422a80":
        //add the down arrow to selected tab
        $(this).addClass("pseudo-active--purple");
        if(window.innerWidth > 600) {
          gsap.to('.hero__img--prod--3--inactive', {
            duration: .25,
            opacity: 0
          })
          gsap.to('.hero__img--prod--1--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--2--inactive', {
            duration: .25,
            opacity: 1
          })
          gsap.to('.hero__img--prod--4--inactive', {
            duration: .25,
            opacity: 1
          })
        }
        //animate the logo
        gsap.to('.hero__logo', {
          duration: .25,
          opacity: 0,
          onComplete: () => {
            gsap.to('.hero__logo--1', {
              opacity: 1
            })
          }
        })
        //animate the copy
        gsap.to('.hero__copy', {
          duration: .25,
          opacity: 0,
          y: 20,
          onComplete: () => {
            $('.hero__copy').html('<div class="hero__copy-row"><span class="hero__span--sans">NEW</span> <span>Smirnoff</span></div> <div class="hero__copy-row"><span>Berry</span> <span>Burst</span> </div>')
          }
        });
        gsap.to('.hero__copy', {
          duration: .25,
          delay: .25,
          opacity: 1,
          y: 0,
        });
        animateOverflow($('.api__navbar'), 500);
        //animate the side tabs
        gsap.to('.hero__tab--3', {
          duration: .25,
          x: 0
        });
        //animate the side tabs
        gsap.to('.hero__tab--1', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--2', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--4', {
          duration: .25,
          x: -140
        });
        $('body').css({
          backgroundImage: "url('hero/marble-bg.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
        break;
        case "#bc0e2d":
        //add the down arrow to selected tab
        $(this).addClass("pseudo-active--red");
        if(window.innerWidth > 600) {
          gsap.to('.hero__img--prod--4--inactive', {
            duration: .25,
            opacity: 0
          });
          gsap.to('.hero__img--prod--1--inactive', {
            duration: .25,
            opacity: 1
          });
          gsap.to('.hero__img--prod--2--inactive', {
            duration: .25,
            opacity: 1
          });
          gsap.to('.hero__img--prod--3--inactive', {
            duration: .25,
            opacity: 1
          });
          
        }
        //animate the logo
        gsap.to('.hero__logo', {
          duration: .25,
          opacity: 0,
          onComplete: () => {
            gsap.to('.hero__logo--2', {
              opacity: 1
            })
          }
        })
        
        //animate the copy
        gsap.to('.hero__copy', {
          duration: .25,
          opacity: 0,
          y: 20,
          onComplete: () => {
            $('.hero__copy').html('<div class="hero__copy-row"><span class="hero__span--sans">THE</span> <span class="hero__span--sans">WORLD\'S</span></div> <div class="hero__copy-row"><span>No.1</span> <span class="hero__span--sans">VODKA</span></div>')
          }
        });
        gsap.to('.hero__copy', {
          duration: .25,
          delay: .25,
          opacity: 1,
          y: 0,
        });

        //animate tabs back to start
        animateOverflow($('.api__navbar'), 500);
       
        //animate the side tabs
        gsap.to('.hero__tab--1', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--2', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--3', {
          duration: .25,
          x: -140
        });
        //animate the side tabs
        gsap.to('.hero__tab--4', {
          duration: .25,
          x: 0
        });
        $('body').css({
          backgroundImage: "url('hero/21-bg.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
        
        break;
        
    }

    $(this).addClass("pseudo-active");

    $(".api").html("");
    Object.keys(dataModel[dId].retailers).forEach(function (k) {
      
      $(".api").append(`
      <div class="api__retailer" style="${
        dataModel[dId].retailers[k].retailer == 'SuperValuIE'
                    ? 'background: #9c002d'
                    : 'background: #fff'
                }">
        <a data-action="csClickToRetailer" href="${dataModel[dId].retailers[k].url}" class="api__a" target="_blank">
          <div data-action="csClickToRetailer" class="api__img-wrapper temp__center">
            <img data-action="csClickToRetailer" src="${dataModel[dId].retailers[k].logo}" class="api__img--logo" />
          </div>
          <div data-action="csClickToRetailer" class="api__price" style="background: ${dataModel[dId].ui.middle.color}">&pound;${dataModel[dId].retailers[k].price}</div>
        </a>
      </div>
      `);
    });
  });

  var elemPositioning = () => {
    gsap.set(".api__bg", {
      y: () => {
        if (window.innerWidth > 475) {
          return -50;
        } else {
          return 0;
        }
      },
    });
  };
  //initial positioning
  elemPositioning();

  //resize positioning
  $(window).resize(function() {
    elemPositioning();
  });

  //initiate 1st tab on load
  switch(props.brandExperience) {
    case '1': 
      $('.api__navbar-option[data-id="1"]').click();
      break;
    case '2': 
      $('.api__navbar-option[data-id="2"]').click();
      break;
    case '3': 
      $('.api__navbar-option[data-id="3"]').click();
      break;
    case '4': 
      $('.api__navbar-option[data-id="4"]').click();
      break;
  }

});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.api__navbar-text {
  &:hover {
    cursor: pointer !important;
  }
}
.cs-t4 .cs_content-buylocally-title-search-input {
  float: left !important;
}
.api__bg {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  display: inline-block;
  position: relative;
  max-width: 700px;
  min-width: 500px;
  z-index: 150;
  @media screen and (max-width: 700px) {
    margin-top: -8px;
    max-width: initial;
    min-width: initial;
  }
  @media screen and (max-width: 475px) {
    border-radius: 0px;
    bottom: 0px;
    left: 0px;
    margin-right: 10px;
    overflow: scroll;
    position: fixed;
    width: 100%;
    z-index: 150;
  }
}
.api__navbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }

  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  height: 62px;
  overflow: scroll;
  padding: 0px 10px;
  position: relative;
  width: 100%;
  z-index: 100;
  @media screen and (max-width: 475px) {
    border-radius: 0px;
  }
  & .api__navbar-option {
    @include flexbox();
    @include align-items(center);
    @include justify-content(center);
    color: #ffffff;
    font-size: 11px;
    font-weight: bold;
    height: 50px;
    font-family: "Mark Pro", sans-serif !important;
    min-width: 200px;
    position: relative;
    text-transform: uppercase;
    width: 200px;
    z-index: 200;
    &:first-child {
      padding-right: 10px;
      &:before {
        content: "";
        background-color: #f00091;
        position: absolute;
        height: 50px;
        left: -10px;
        top: 0;
        width: 40px;
        z-index: -1;
      }
    }
    &:last-child {
      padding-left: 10px;
    }
    &:not(:first-child):not(:last-child) {
      padding: 0px 10px;
    }
    &:not(:first-child) {
      border-left: 1px solid #ffffff;
    }
    &:last-child:before {
      content: "";
      background-color: #bc0e2d;
      position: absolute;
      height: 50px;
      right: -10px;
      top: 0;
      width: 40px;
      z-index: -1;
    }
  }
}
.api__navbar-option:after {
  content: "";
  bottom: -9px;
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #bc0e2d;
}
.pseudo-active:after {
  opacity: 1;
}
.pseudo-active--red:after {
  border-top: 10px solid #bc0e2d;
}
.pseudo-active--yellow:after {
  border-top: 10px solid #fab80e;
}
.pseudo-active--pink:after {
  border-top: 10px solid #f00091;
}
.pseudo-active--purple:after {
  border-top: 10px solid #422a80;
}
.api {
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  padding: 0px 12px 12px 12px;
  width: 100%;

  @media screen and (max-width: 475px) {
    @include justify-content(flex-start);
  }
}
.api__retailer {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  max-width: 100px;
  min-width: 70px;
  position: relative;
  &:not(:last-child) {
    margin-right: 10px;
  }
  &:last-child:after {
    content: "";
    position: absolute;
    height: 100%;
    right: -10px;
    top: 0;
    background: none;
    width: 20px;
  }
  @media screen and (max-width: 475px) {
    max-width: 70px;
  }
}
.api__img-wrapper {
  padding: 5px !important;
}
.api__img--logo {
  display: block;
  width: 100%;
}
.api__a {
  color: #333333;
  text-decoration: none;
}
.api__price {
  border-radius: 0px 0px 5px 5px;
  color: #ffffff;
  font-family: "Mark Pro", sans-serif;
  font-size: 12px;
  font-weight: bold;
  padding: 5px 0px;
  text-align: center;
}
</style>